/**
 * Recent searches (Phase 10 task list), kept in `localStorage`.
 *
 * Deliberately *only* in the browser: a reader's queries are their own, and sending them
 * to the server to build a per-reader history would be a privacy decision nobody has
 * made. The analytics pipeline already logs anonymous query text for the zero-result
 * report (Phase 6); this is a convenience with a different owner.
 */
const KEY = 'nk:recent-searches';
const LIMIT = 6;

export function readRecentSearches(): string[] {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed: unknown = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed)
      ? parsed.filter((item): item is string => typeof item === 'string')
      : [];
  } catch {
    // Private browsing, blocked storage, corrupt JSON: a missing convenience, not an error.
    return [];
  }
}

export function rememberSearch(query: string): string[] {
  const trimmed = query.trim();
  if (trimmed.length < 2) return readRecentSearches();

  const next = [trimmed, ...readRecentSearches().filter((item) => item !== trimmed)].slice(
    0,
    LIMIT,
  );
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // Ignored for the same reason as above.
  }
  return next;
}

export function clearRecentSearches(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // Ignored.
  }
}
